import React from "react"

class NightAuditStatusBoardHeader extends React.Component {
  //   constructor(props) {
  //       super(props);

  //       this.onChangeDate = this.onChangeDate.bind(this);
  //       this.onToday = this.onToday.bind(this);
  //       this.onPrev = this.onPrev.bind(this);
  //       this.onNext = this.onNext.bind(this);
  //       // this.onChangeView = this.onChangeView.bind(this);
  //   }

  //   componentDidMount() {
  //       this.updateDatepicker();
  //   }

  //   componentDidUpdate() {
  //       this.updateDatepicker();
  //   }

  //   render() {
  //       var today = this.props.currentDate.clone();
  //       var tomorrow = today.clone().add(1).day();
  //       var date_format = DateHelper.rubyToDateJS(this.props.dateFormat);

  //       return (
  //           <div className="row dashboard-buttons">
  //               <div className="col-sm-12">
  //                   <div className="text-center">
  //                       <button type="button" className="prev-button btn btn-dark" onClick={this.onPrev}><span className="icon ss-left"></span></button>
  //                       <h4 style={{ marginTop: '8px', marginBottom: '22px', display: 'inline-block' }} ref="datepicker">{this.props.currentDate.toString('dddd, ' + date_format)}</h4>
  //                       <button type="button" className="next-button btn btn-dark" onClick={this.onNext}><span className="icon ss-right"></span></button>
  //                   </div>
  //               </div>
  //           </div>
  //       );
  //   }

  //   updateDatepicker() {
  //       /*
  //       * If $ and document are defined, it means we're not pre-rendering)
  //       * We can bind event handlers, use jQuery, etc
  //       */
  //       if ($ && document) {
  //           if (this.datepicker) {
  //               this.datepicker.off('changeDate');
  //               this.datepicker.datepicker('remove');
  //               delete this.datepicker;
  //           }

  //           var today = DateHelper.current();
  //           var twoYearsFromToday = today.clone().add(2).years();

  //           this.datepicker = $(this.refs.datepicker).datepicker({ maxViewMode: 0, defaultViewDate: this.defaultDate(), startDate: today, endDate: twoYearsFromToday, autoclose: true, todayBtn: 'linked' });
  //           this.datepicker.on('changeDate', this.onChangeDate);
  //       }
  //   }

  //   defaultDate() {
  //       return {
  //           year: this.props.currentDate.getFullYear(),
  //           month: this.props.currentDate.getMonth(),
  //           day: this.props.currentDate.getDate()
  //       }
  //   }

  //   onChangeDate() {
  //       var $input = $(this.refs.datepicker);

  //       if ($input.data('datepicker')) {
  //           var date = $input.data('datepicker').getDate();

  //           this.props.onChange('currentDate', date);
  //       }
  //   }

  //   onToday() {
  //       // HousekeepingStatusBoardActions.gotoDate(new Date());
  //       this.props.onChange('currentDate', new Date())
  //   }

  //   // onChangeView(e) {
  //   //     e.preventDefault();

  //   //     DashboardActions.setActiveTab(e.target.dataset.view);
  //   // }


  //   onPrev() {
  //       var prevDate = new Date(this.props.currentDate.getTime());
  //       prevDate.setDate(prevDate.getDate() - 1);

  //       this.props.onChange('currentDate', prevDate);
  //   }



  //   onNext() {
  //       var nextDate = new Date(this.props.currentDate.getTime());
  //       nextDate.setDate(nextDate.getDate() + 1);

  //       this.props.onChange('currentDate', nextDate);
  //   }

  //   /**
  // * Determines if two dates are the same day/month/year (ignoring time)
  // */
  //   sameDay(date1, date2) {
  //       return date1.getDate() == date2.getDate() && date1.getMonth() == date2.getMonth() && date1.getFullYear() == date2.getFullYear();
  //   }
};

export default NightAuditStatusBoardHeader